import React, { useCallback, useEffect, useState } from "react";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { useLocation } from "react-router-dom";
import "./index.less";
import { FocusSDK } from "@/utils";
import { UserState } from "@/models/user";
import { connect } from "dvajs";
import { Modal, message } from "antd";
import { useTranslation } from "react-i18next";
import ChatState from "@/types/chat/State";
import { usePrevious } from "@/utils/chat/index";
import { Employee } from "@/types/chat";
import { getRealConfig } from "@/utils/tools";
import { getAppVersion } from "@/utils/getVersion";

function MessageMerge({
  setshowSyncMsgTip,
  currentEmployee,
  teamConfig
}: {
  setshowSyncMsgTip: Function;
  currentEmployee: Employee;
  teamConfig: any;
}) {
  const [isModalVisible, setVisible] = useState(false);
  const location = useLocation();
  const { t } = useTranslation("chat");
  const preUser = usePrevious(currentEmployee);
  const { imService } = React.useContext<GlobalContextConfig>(GlobalContext);

  const { title, content, cancelText, okText, tip } = {
    title: t("message_sync_modal.title"),
    content: t("message_sync_modal.content"),
    cancelText: t("message_sync_modal.cancelText"),
    okText: t("message_sync_modal.okText"),
    tip: t("message_sync_modal.tip")
  };
  const currentTime = new Date().getTime();
  const [countDown, setCountDown] = useState(5);

  const getRoamTime = () => {
    const queryKey = currentEmployee?.accountType === 1 ? "publicEmpRoamTime" : "normalRoamTime";
    const value = getRealConfig(teamConfig, {}, queryKey);
    return value || 7;
  };

  const onOk = async () => {
    setshowSyncMsgTip(true);

    const res = await imService.getHistoryMessage({
      startTime: currentTime - getRoamTime() * 24 * 3600 * 1000,
      endTime: currentTime
    });
    if (res === 1) {
      setshowSyncMsgTip(false);
      message.success("消息同步成功");
    }
    onClose();
  };
  const onClose = async () => {
    setVisible(false);
    const version = getAppVersion(FocusSDK);
    await imService?.setAppVersion(version);
  };

  const isNewHand = useCallback(async () => {
    const isNewHandSync = await imService?.isNewhand();
    if (isNewHandSync) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [imService]);

  useEffect(() => {
    if (isModalVisible) {
      if (countDown > 0) {
        setTimeout(() => {
          setCountDown(countDown - 1);
        }, 1000);
      } else {
        onClose();
      }
    }
  }, [countDown, isModalVisible]);

  useEffect(() => {
    const isWeb = FocusSDK.getDeviceInfo().platform === "web";
    if (!isWeb && !preUser?.userId && currentEmployee?.userId) {
      isNewHand();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preUser?.userId, currentEmployee?.userId]);
  if (location.pathname === "/login") {
    return null;
  }
  return (
    <Modal
      title={title}
      visible={isModalVisible}
      onOk={onOk}
      onCancel={() => onClose()}
      okText={okText}
      cancelText={`${cancelText} (${countDown}S)`}
      centered={true}
      className="sync-model"
    >
      <div className="title-modal">{content}</div>
      <div className="tip-modal">{tip}</div>
    </Modal>
  );
}

function mapStateToProps({ user, chat }: { user: UserState; chat: ChatState }) {
  return {
    teamConfig: user.teamConfig,
    currentEmployee: chat.currentEmployee
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    setshowSyncMsgTip(data: any) {
      dispatch({ type: "chat/setshowSyncMsgTip", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MessageMerge);
